<!--  -->
<template>
  <div>
    <div class="choose_account">
      <div class="choose_title">投手类型：</div>
      <el-select
        v-model="pitcherType"
        style="width:250px"
        placeholder="请选择投手类型"
      >
        <el-option
          v-for="item in pitcherOptions"
          :key="item.value"
          :label="item.description"
          :value="item.value"
        />
      </el-select>
    </div>
    <div class="choose_account">
      <div class="choose_title">短剧类型：</div>
      <el-select
        v-model="type"
        style="width:250px"
        placeholder="请选择短剧类型"
      >
        <el-option
          v-for="item in dramaOptions"
          :key="item.value"
          :label="item.description"
          :value="item.value"
        />
      </el-select>
    </div>
    <div class="choose_account">
      <div class="choose_title">名称：</div>
      <el-input
        v-model="name"
        style="width:250px"
        placeholder="名称"
      />
    </div>
    <div class="choose_account">
      <div class="choose_title">短剧id：</div>
      <el-input
        v-model="book_id"
        style="width:250px"
        placeholder="短剧"
      />
    </div>
    <div class="choose_account">
      <div class="choose_title">截止时间：</div>
      <el-date-picker
        v-model="value1"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="选择日期"
      />
    </div>
    <div style="text-align: center;margin-top: 60px;">
      <el-button
        type="primary"
        @click="savebit"
      >保存</el-button>
    </div>

  </div>
</template>
<script>
import { changduplayletadd, changduplayletupdate, getDramaTypeList } from '@/api/providerAccountManagement/servicePorviderList.js'
export default {
  components: {},
  data() {
    return {
      name: '', // biz名称
      book_id: '', // 手机编码
      type: null, // 短剧类型
      dialogVisible: false, // 弹窗
      id: '', // 选择的公众号id
      idname: '', // 选择的公众号名字
      value1: '',
      addtype: null,
      ids: null,
      dramaOptions: [
      ],
      pitcherType: null,
      pitcherOptions: [
      ]
    }
  },
  created() {
    this.ev_getDramaTypeList()
  },
  mounted() {},
  methods: {
    async ev_getDramaTypeList() {
      const { data } = await getDramaTypeList()
      console.log('resData', data)
      this.pitcherOptions = data.pitcher_type
      this.dramaOptions = data.type
    },
    chooseaccount() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.chooseview.send(this.id)
      })
    },
    callback(val) {
      console.log('val', val)
      this.id = val.authorizer_appid
      this.idname = val.account_name
      this.dialogVisible = false
    },
    send(val, item) {
      if (val === 1) {
        console.log('新增')
        this.addtype = val
        // 重置表单
        this.name = ''
        this.book_id = ''
        this.type = null
        this.value1 = ''
        this.ids = null
      } else {
        this.addtype = val
        this.name = item.name
        this.book_id = item.book_id
        this.type = item.type
        this.value1 = item.limit_date
        this.ids = item.id
        console.log('编辑', item)
      }
      console.log('val', val)
    },
    async savebit() {
      if (!this.type) {
        this.$message.error('请选择短剧类型')
        return
      }
      if (this.name === '') {
        this.$message.error('请输入名称')
        return
      }
      if (this.book_id === '') {
        this.$message.error('请输入短剧id')
        return
      }
      // if (this.book_id === '') {
      //   this.$message.error('请输入短剧id')
      //   return
      // }
      if (this.value1 === '') {
        this.$message.error('请选择截至时间')
        return
      }
      if (this.addtype === 1) {
        const data = await changduplayletadd({
          name: this.name,
          book_id: this.book_id,
          type: this.type,
          limit_date: this.value1,
          pitcher_type: this.pitcherType
        })
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.$emit('updatawe')
        console.log('data', data)
      } else {
        const data = await changduplayletupdate({
          id: this.ids,
          name: this.name,
          book_id: this.book_id,
          type: this.type,
          limit_date: this.value1,
          pitcher_type: this.pitcherType
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$emit('updatawe')
        console.log('data', data)
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.choose_account {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.choose_title {
  width: 100px;
  text-align: right;
}
</style>
